// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
import { DigitInput } from '../ReactControls/elements/DigitInput';
export class DigitInputRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    attachEventHandlers(props) {
        props.onChange = (value) => {
            this.fire('valueChanged', this, value);
            void this.set('value', value);
        };
    }
}
ReactToRactiveAdapter.extendWith(DigitInputRactive, {
    template: '<div class="digit-input-host"></div>',
    mountContainer: '.digit-input-host',
    reactComponent: DigitInput,
    data: () => ({
        value: '',
        hasError: false,
        autofocus: false
    })
});
